import { combineReducers } from 'redux';
import {
  REPORTS_SET_LIST_SALES_SUMMARY,
  REPORTS_SET_SALES_TYPE,
  REPORTS_SET_LIST_GROSS_PROFIT,
  REPORTS_SET_PAYMENT_METHODS,
  REPORTS_SET_ITEM_SALES,
  REPORTS_RESET_ITEM_SALES,
  REPORTS_SET_CATEGORY_SALES,
  REPORTS_RESET_CATEGORY_SALES,
  REPORTS_SET_MODIFIER_SALES,
  REPORTS_SET_DISCOUNTS,
  REPORTS_SET_TAXES,
  REPORTS_SET_GRATUITY,
  REPORTS_SET_COLLECTEDBY,
  REPORTS_SET_SERVEDBY,
  REPORTS_SALES_SUMMARY_SET_START_END_DATE,
  REPORTS_SALES_TYPE_SET_START_END_DATE,
  REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE,
  REPORTS_SALES_ITEM_SALES_SET_START_END_DATE,
  REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE,
  REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE,
  REPORTS_SALES_DISCOUNTS_SET_START_END_DATE,
  REPORTS_SALES_TAXES_SET_START_END_DATE,
  REPORTS_SALES_GRATUITY_SET_START_END_DATE,
  REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE,
  REPORTS_SALES_SERVEDBY_SET_START_END_DATE,
  REPORTS_SALES_SET_OUTLETS,
  REPORTS_SALES_SHOW_LOADING_SPINNER,
} from 'actions/reports/sales/constants';
import moment from 'moment';

import createReducer from 'utils/createReducer';
import salesTypeReport from './salesTypeReport';
import modifierSalesReport from './modifierSalesReport';

const initialCategorySalesState = {
  categorySalesReport: [],
  categorySalesSummaryReport: {},
};
const categorySales = createReducer(initialCategorySalesState, {
  [REPORTS_SET_CATEGORY_SALES]: (draft, { payload }) => payload.categorySales,
  [REPORTS_RESET_CATEGORY_SALES]: () => initialCategorySalesState,
});

const discounts = createReducer([], {
  [REPORTS_SET_DISCOUNTS]: (draft, { payload }) => payload.discounts,
});

const endDate = createReducer(
  moment()
    .add(-1, 'years')
    .endOf('year'),
  {
    [REPORTS_SALES_SUMMARY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_TYPE_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_ITEM_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_DISCOUNTS_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_TAXES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_GRATUITY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,

    [REPORTS_SALES_SERVEDBY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.endDate,
  }
);

const gratuities = createReducer(
  { reports_gratuities: [], total_gratuity_collected: 0 },
  {
    [REPORTS_SET_GRATUITY]: (draft, { payload }) => payload.gratuities,
  }
);

const grossProfit = createReducer([], {
  [REPORTS_SET_LIST_GROSS_PROFIT]: (draft, { payload }) => payload.grossProfit,
});

const initialItemSalesState = {
  itemSalesReport: [],
  itemSummaryReport: {},
};
const itemSales = createReducer(initialItemSalesState, {
  [REPORTS_SET_ITEM_SALES]: (draft, { payload }) => payload.itemSales,
  [REPORTS_RESET_ITEM_SALES]: () => initialItemSalesState,
});

const modifierSales = createReducer([], {
  [REPORTS_SET_MODIFIER_SALES]: (draft, { payload }) => payload.modifierSales,
});

const outlets = createReducer([], {
  [REPORTS_SALES_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const paymentMethods = createReducer(
  {
    numberOfTransactions: 0,
    totalCollected: 0,
    paymentMethods: [],
  },
  {
    [REPORTS_SET_PAYMENT_METHODS]: (draft, { payload }) =>
      payload.paymentMethods,
  }
);

const sales = createReducer([], {
  [REPORTS_SET_LIST_SALES_SUMMARY]: (draft, { payload }) => payload.sales,
});

const salesType = createReducer([], {
  [REPORTS_SET_SALES_TYPE]: (draft, { payload }) => payload.salesTypes,
});

const servers = createReducer(
  { servers: [], total_collected: 0, total_number_transaction: 0 },
  {
    [REPORTS_SET_SERVEDBY]: (draft, { payload }) => payload.servers,
  }
);

const showLoadingSpinnerReport = createReducer(false, {
  [REPORTS_SALES_SHOW_LOADING_SPINNER]: (draft, { payload }) =>
    payload.showLoadingSpinnerReport,
});

const staffs = createReducer(
  {
    staff_reports: {},
    total_transaction_amount: 0,
    total_transaction_count: 0,
  },
  {
    [REPORTS_SET_COLLECTEDBY]: (draft, { payload }) => payload.staffs,
  }
);

const startDate = createReducer(
  moment()
    .add(-1, 'years')
    .startOf('year'),
  {
    [REPORTS_SALES_SUMMARY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_TYPE_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_ITEM_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_DISCOUNTS_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_TAXES_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_GRATUITY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,

    [REPORTS_SALES_SERVEDBY_SET_START_END_DATE]: (draft, { payload }) =>
      payload.startDate,
  }
);

const taxes = createReducer(
  { reports_taxes: [], total_tax_collected: 0 },
  {
    [REPORTS_SET_TAXES]: (draft, { payload }) => payload.taxes,
  }
);

export default combineReducers({
  categorySales,
  discounts,
  endDate,
  gratuities,
  // FIXME camelCase
  gross_profit: grossProfit,
  itemSales,
  modifierSales,
  outlets,
  paymentMethods,
  sales,
  // FIXME camelCase
  sales_type: salesType,
  servers,
  showLoadingSpinnerReport,
  staffs,
  startDate,
  taxes,

  // Start breaking up this legacy reducer
  salesTypeReport,
  modifierSalesReport,
});
